import KPasswordField from "./KPasswordField";
import { VExpandTransition, VIcon } from "vuetify/lib";
import { ValidationProvider } from "vee-validate";

export default {
	name: "KPasswordCreateField",

	extends: KPasswordField,

	data: () => ( {
		hasCapitalLetter: false,
		hasLowercaseLetter: false,
		hasNumber: false,
		meetsMinLength: false,
		passwordCriteriaVisible: false
	} ),

	computed: {
		fieldName() {
			return this.validationName || this.$attrs.name;
		},

		hasErrors() {
			return !this.hasCapitalLetter
				|| !this.hasLowercaseLetter
				|| !this.hasNumber
				|| !this.meetsMinLength;
		},

		modifiedValidationRules() {
			if ( typeof this.validationRules === "undefined" ) {
				return "validPassword";
			} else if ( typeof this.validationRules === "string" ) {
				return `${this.validationRules}|validPassword`;
			} else if ( typeof this.validationRules === "object" ) {
				const rulesCopy = JSON.parse( JSON.stringify( this.validationRules ) );

				rulesCopy.validPassword = true;

				return rulesCopy;
			}

			return this.validationRules;
		},

		passwordCriteria() {
			return [
				{
					isValid: this.hasCapitalLetter,
					message: "Has a capital letter"
				},
				{
					isValid: this.hasLowercaseLetter,
					message: "Has a lowercase letter"
				},
				{
					isValid: this.hasNumber,
					message: "Has a number"
				},
				{
					isValid: this.meetsMinLength,
					message: "Is 6+ characters long"
				}
			];
		},

		genPasswordCriteria() {
			return <VExpandTransition>
				<ul
					class="pa-0"
					style="list-style-type: none;"
					vShow={this.passwordCriteriaVisible}
				>
					{this.passwordCriteria.map( criteria =>
						<li class={criteria.isValid ? "success--text" : "error--text"}>
							<VIcon
								color={criteria.isValid ? "success" : "error"}
								style="vertical-align: middle;"
							>{criteria.isValid ? "done" : "clear"}</VIcon>

							{criteria.message}
						</li>
					)}
				</ul>
			</VExpandTransition>;
		},

		fieldListeners() {
			return {
				...this.$listeners,

				input: e => this.$emit( "input", e ),

				"~focus": () => {
					if ( this.$attrs.required ) {
						this.passwordCriteriaVisible = true;
					}
				},

				focus: () => {
					if ( !this.$attrs.required ) {
						this.passwordCriteriaVisible = true;
					}
				},

				blur: () => {
					if ( !this.$attrs.required && !this.internalValue ) {
						this.passwordCriteriaVisible = false;
					}
				}
			};
		}
	},

	watch: {
		hasErrors( hasErrors ) {
			if ( hasErrors ) {
				this.passwordCriteriaVisible = true;
			}
		}
	},

	render() {
		return <ValidationProvider
			bails={false}
			debounce={0}
			mode="aggressive"
			rules={this.$attrs.required || this.internalValue ? "hasCapitalLetter|hasLowercaseLetter|hasNumber|min:6" : null}
			slim
			scopedSlots={{
				default: ( { failedRules } ) => {
					this.hasCapitalLetter = this.internalValue
						&& !failedRules.hasOwnProperty( "hasCapitalLetter" );

					this.hasLowercaseLetter = this.internalValue
						&& !failedRules.hasOwnProperty( "hasLowercaseLetter" );

					this.hasNumber = this.internalValue
						&& !failedRules.hasOwnProperty( "hasNumber" );

					this.meetsMinLength = this.internalValue
						&& !failedRules.hasOwnProperty( "min" );

					return <div>
						<KPasswordField
							{...{
								attrs: this.$attrs,
								props: {
									...this.$props,
									validationMode: "aggressive",
									validationRules: this.modifiedValidationRules
								},
								on: this.fieldListeners
							}}
							vModel={this.internalValue}
						></KPasswordField>

						{this.genPasswordCriteria}
					</div>;
				}
			}}
		></ValidationProvider>;
	}
};
